import { useMutation } from '@apollo/client';
import { UpdateContactInformationMutation } from '@typings/operations';
import { updateContactInformationMutation } from '../queries';

export const useUpdateContactInformation = () => {
  return useMutation<UpdateContactInformationMutation>(
    updateContactInformationMutation
  );
};
